(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/news/assets/news.js') >= 0) return;  svs.modules.push('/components/sportinfo/news/assets/news.js');
"use strict";


const {
  useFetchNews,
  useNews
} = svs.components.sportinfo.newsTT.hooks;
const {
  ReducerState
} = svs.components.sport.tipsenShared;
const {
  NewsArticle
} = svs.components.sportinfo.news;
const {
  useSelector
} = ReactRedux;
const {
  SkeletonConfigKey,
  SkeletonWrapper,
  SkeletonConfig
} = svs.components.sportinfo.skeletonWrapper;
const selectIsFetching = state => state.newsTT.state === ReducerState.Pending;
const selectIsDone = state => state.newsTT.state === ReducerState.Done || state.newsTT.state === ReducerState.Rejected;
const News = _ref => {
  let {
    branding,
    matchId,
    className,
    FallbackComp
  } = _ref;
  useFetchNews(matchId);
  const articles = useNews(matchId);
  const isFetching = useSelector(selectIsFetching);
  const isDone = useSelector(selectIsDone);
  const hasNews = articles.length > 0;

  return React.createElement("div", className ? {
    className
  } : {}, isFetching && React.createElement(SkeletonWrapper, {
    config: SkeletonConfig[SkeletonConfigKey.TT_NEWS].skeletonConfig
  }), isDone && !hasNews && React.createElement(FallbackComp, {
    branding: branding
  }, "F\xF6r tillf\xE4llet har vi inga nyheter"), isDone && hasNews && articles.map(article => React.createElement(NewsArticle, {
    author: article.importOrigin,
    body: article.body,
    headline: article.title,
    key: article.id,
    published: new Date(article.published)
  })));
};
setGlobal('svs.components.sportinfo.news.News', News);

 })(window);